import { FieldFormatType } from '../../../types/form/field-format-type';
import { dateFieldValidationConfigValidator, otherFieldValidationConfigValidator, textFieldValidationConfigValidator } from '../../../types/form/field-validation-config';
export const defaultMemberFormValidationConfig = {
    givenName: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 100
    },
    familyName: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 100
    },
    mobileNumber: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 25
    },
    homeNumber: {
        type: FieldFormatType.Text,
        required: false,
        maxLength: 25
    },
    dateOfBirth: {
        type: FieldFormatType.Date,
        minAge: undefined,
        required: true
    },
    gender: {
        type: FieldFormatType.Other,
        required: true
    },
    nationalId: {
        type: FieldFormatType.Text,
        required: false,
        maxLength: 100
    },
    externalId: {
        type: FieldFormatType.Text,
        required: false,
        maxLength: 100
    },
    address: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 100
    },
    suburb: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 100
    },
    city: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 100
    },
    state: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 100
    },
    postCode: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 100
    },
    primarySite: {
        type: FieldFormatType.Other,
        required: false
    },
    favouriteGenres: {
        type: FieldFormatType.Other,
        required: false
    },
    newsletter: {
        type: FieldFormatType.Other,
        required: false
    },
    termsAndConditions: {
        type: FieldFormatType.Other,
        required: true
    },
    allowThirdPartyProfiling: {
        type: FieldFormatType.Other,
        required: false
    },
    allowThirdPartyContact: {
        type: FieldFormatType.Other,
        required: false
    },
    captcha: {
        type: FieldFormatType.Other,
        required: true
    }
};
export const memberFormValidationConfigValidatorSchema = {
    givenName: textFieldValidationConfigValidator,
    familyName: textFieldValidationConfigValidator,
    mobileNumber: textFieldValidationConfigValidator,
    homeNumber: textFieldValidationConfigValidator,
    dateOfBirth: dateFieldValidationConfigValidator,
    gender: otherFieldValidationConfigValidator,
    nationalId: textFieldValidationConfigValidator,
    externalId: textFieldValidationConfigValidator,
    address: textFieldValidationConfigValidator,
    suburb: textFieldValidationConfigValidator,
    city: textFieldValidationConfigValidator,
    state: textFieldValidationConfigValidator,
    postCode: textFieldValidationConfigValidator,
    primarySite: otherFieldValidationConfigValidator,
    favouriteGenres: otherFieldValidationConfigValidator,
    newsletter: otherFieldValidationConfigValidator,
    termsAndConditions: otherFieldValidationConfigValidator,
    allowThirdPartyProfiling: otherFieldValidationConfigValidator,
    allowThirdPartyContact: otherFieldValidationConfigValidator,
    captcha: otherFieldValidationConfigValidator
};
